import { PLAN_URL } from 'src/config/api.config';
import ApiService from './Api.service';

class PlanService extends ApiService {
  constructor() {
    super(PLAN_URL);
  }
}

export default new PlanService();
